/* eslint-disable */
// @ts-nocheck
import { createSelector } from 'reselect';
import { createInitialState } from '../reducers/DruidReducer';
import type { DruidReducer, Filters } from '../../main/types/druidTypes';
import { mapToEventName } from '../support/utils';
import { getFlipperState } from '../../main/selectors/FlipperSelectors';
const EMPTY_ARRAY = [];
const EMPTY_OBJECT = {};
export function getDruidState(state: any): DruidReducer {
  return (state && state.druid) || createInitialState();
}
export const getDruidFilters: (state: any) => Filters = createSelector(
  getDruidState,
  (druidState) => druidState.filters || EMPTY_OBJECT
);
export const getQueries: (state: any) => any = createSelector(getDruidState, (state) => ({ ...state.queries }));
export const getReportTotals: (state: any) => any = createSelector(getDruidState, (state) => ({ ...state.reportTotals }));
export const getLoadingState: (state: any) => boolean = createSelector(getQueries, (queries) =>
  Object.values(queries)
    .map((query: any) => query.loading)
    .some(Boolean)
);
export const getAllEventNamesLast30d: (state: any) => string[] = createSelector(getDruidState, (state) =>
  (state.allEventsLast30d || []).filter(Boolean).map(mapToEventName)
);
export const selectAllEventsLast30d: (state: any) => string[] = createSelector(
  getDruidState,
  (state) => state.allEventsLast30d || EMPTY_ARRAY
);
export const selectAllEventAliasesLast30d: (state: any) => Record<string, string[]> = createSelector(
  getDruidState,
  (state) => state.allEventAliasesLast30d || EMPTY_OBJECT
);

function flattenEventAliases(eventAliasesByEventName: Record<string, string[]>): string[] {
  return Object.values(eventAliasesByEventName).reduce((allEventAliases, eventAliases) => {
    // $FlowFixMe
    return [...allEventAliases, ...eventAliases];
  }, []);
}

export const getDedupedAllEventNamesLast30d: (state: any) => string[] = createSelector(
  getAllEventNamesLast30d,
  (allEventNamesLast30d) => {
    const dedupedAllEventNames = allEventNamesLast30d.filter(
      (eventName, index, allEventNames) => allEventNames.indexOf(eventName) === index
    );
    return dedupedAllEventNames.map(mapToEventName);
  }
);
export const selectFlattenedEventAliasesLast30d: (state: any) => string[] = createSelector(
  selectAllEventAliasesLast30d,
  (allEventAliasesLast30d) => {
    // $FlowFixMe
    return flattenEventAliases(allEventAliasesLast30d);
  }
);
export const getAllEventAliasesForEvent: (
  state: any,
  props?: {
    eventName?: string;
  }
) => string[] = createSelector(
  getDruidState,
  (state, props) => (props && props.eventName) || '',
  (state, eventName) => (state.allEventAliasesLast30d || {})[eventName] || EMPTY_ARRAY
);

/**
 * Get list of custom events from druid state.
 */
export const getCustomEventList: (state: any) => string[] = createSelector(
  getDruidState,
  (state) => state.custom_event_list || EMPTY_ARRAY
);
export const getCustomEventNameList: (state: any) => string[] = createSelector(getCustomEventList, (customEventKeys) =>
  customEventKeys.map(mapToEventName)
);
export const selectHasCustomerEventAliasesLast30d: (state: any) => boolean | null | undefined = createSelector(
  getDruidState,
  (state) => state.hasCustomerEventAliasesLast30d
);
export const getDruidLastRateLimitHit: (state: any) => boolean | null | undefined = createSelector(
  getDruidState,
  getFlipperState,
  (druid, flipper) => {
    if (flipper.features && flipper.features.druid_rate_limit_modal) {
      return druid.lastRateLimitHit;
    }

    return undefined;
  }
);
export const selectDruidLimit: (state: any) => number | null | undefined = createSelector(
  getDruidState,
  (state) => state.druidLimit
);
